import { useForm } from "react-hook-form";
import { StyledContactForm } from "./ContactForm.styled";
import { Box, Button, TextField, Typography } from "@mui/material";
import { Message } from "../../Models/Message";
import { language, placeholders } from "../../Globals/Constants";

type ContactFormProps = {
  onSend: (message: Message) => void;
};

export const ContactForm = ({ onSend }: ContactFormProps) => {
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<Message>();

  const onSubmit = (data: Message) => {
    onSend(data);
    reset();
  };

  return (
    <StyledContactForm onSubmit={handleSubmit(onSubmit)}>
      <Typography variant="h2">Contactformulier
      </Typography>
      <Box className="contactformrow">
        <Typography variant="h4">
          Voornaam<span>*</span>
        </Typography>
        <TextField
          {...register("firstName", {
            required: language.requiredInput,
          })}
          placeholder={placeholders.firstName}
          error={!!errors.firstName}
          helperText={errors?.firstName?.message}
          InputLabelProps={{ shrink: true }}
        />
      </Box>
      <Box className="contactformrow">
        <Typography variant="h4">
          Achternaam<span>*</span>
        </Typography>
        <TextField
          {...register("lastName", {
            required: language.requiredInput,
          })}
          placeholder={placeholders.lastName}
          error={!!errors.lastName}
          helperText={errors?.lastName?.message}
          InputLabelProps={{ shrink: true }}
        />
      </Box>
      <Box className="contactformrow">
        <Typography variant="h4">
          Email<span>*</span>
        </Typography>
        <TextField
          {...register("email", {
            required: language.requiredInput,
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: language.invalidEmail,
            },
          })}
          placeholder={placeholders.email}
          error={!!errors.email}
          helperText={errors?.email?.message}
          InputLabelProps={{ shrink: true }}
        />
      </Box>
      <Box className="contactformrow">
        <Typography variant="h4">
          Onderwerp<span>*</span>
        </Typography>
        <TextField
          {...register("subject", {
            required: language.requiredInput,
          })}
          placeholder={placeholders.contactsubject}
          error={!!errors.subject}
          helperText={errors?.subject?.message}
          InputLabelProps={{ shrink: true }}
        />
      </Box>
      <Box className="contactformrow message">
        <Typography variant="h4">
          Uw Bericht<span>*</span>
        </Typography>
        <TextField
          {...register("message", {
            required: language.requiredInput,
          })}
          placeholder={placeholders.contactmessage}
          error={!!errors.message}
          helperText={errors?.message?.message}
          InputLabelProps={{ shrink: true }}
          multiline
          InputProps={{
            rows: 5,
          }}
        />
      </Box>

      <Button type="submit">Versturen</Button>
    </StyledContactForm>
  );
};
